import { getToken, removeToken, setTokenStorage } from './tokenStorage';

/**
 * Stores the access token, preserving any refresh token already held.
 *
 * Replacing the whole entry here would drop the refresh token, leaving nothing to refresh with.
 */
export const setToken = (accessToken?: string): void => {
  if (!accessToken) {
    removeToken();
    return;
  }

  setTokenStorage({ ...getToken(), accessToken });
};
